import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _ from 'lodash';

import { Modal, Button, ListTile, Dropdown, Tabs } from 'components'
import { ProfileTab, PreferencesTab, SubscriptionTab } from './Tabs';
import { FaHome, FaTimes, FaLayerGroup, FaUserAlt, FaSlidersH, FaUserFriends, FaCreditCard} from 'react-icons/fa'

import * as actionCreators from 'store/actions'

const Wrapper = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`

const Container = styled.div`
    width: 100%;
    max-width: 50rem;
    /* height: 100%; */
    overflow: auto;
    background: var(--primary-color);
    padding: 1rem;

    display:  grid;
    grid-template-columns: 1fr;
    /* grid-template-columns: 15rem 1fr; */

    border-radius: 5px;
`

const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 1rem;
    width: 100%;
`

const Title = styled.div`
    font-weight: bolder;
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
    width: 100%;
`

const Side = styled.div`
    background-color: var(--secondary-color);
    padding: 1rem;
    border-radius: 5px;
`

const Body = styled.div`
    padding: ${props => props.padding};
`

class SettingsModule extends Component {
    constructor(props){
        super(props);
        this.state = {
            tab: this.props.section ? this.props.section.toLowerCase() : 'profile'
        }

        this.iconStyle = {
            color: 'var(--icon-color)'
        }
        this.styles = {
            fontWeight: 'bolder',
            fontSize: '0.9rem',
            lineHeight: '0.9rem',
            height: '2rem'
        }
        this.selectedTile = {
            fontWeight: 'bolder',
            fontSize: '0.9rem',
            lineHeight: '0.9rem',
            height: '2rem',
            backgroundColor: 'var(--primary-accent-color)',
        }
        this.dropdownStyle = {
            width: '10rem', 
            padding: '0.5rem', 
            // fontWeight: 'bolder', 
            fontSize: '0.9rem', 
            backgroundColor: 'var(--secondary-color)', 
            borderColor: 'transparent', 
            margin:'0'
        }
        this.tabs = {
            profile: 'Profile',
            preferences: 'Preferences',
            subscription: 'Subscription',
            // shortcuts: 'Shortcuts',
            // about: 'About'
        }
        this.tabIcons = {
            profile: <FaUserAlt/>,
            preferences: <FaSlidersH/>,
            teams: <FaUserFriends/>,
            plans: <FaLayerGroup/>,
            billing: <FaCreditCard/>
        }
        this.tabStyle = {
            main: {
                width: 'min-content',
                backgroundColor: 'var(--secondary-color)'
            },
            tab: {
                width: 'min-content',
                padding: '0.4rem',
                borderRadius: 0,
                backgroundColor: 'var(--primary-color)',
                hoverTextColor: 'var(--focus-color)'
            }
        }
        console.log('construct settings')
    }

    _closeModal = () => {
        this.props.setModal(null,null)
        document.body.style.overflowY = 'auto';
    }

    render() {
        let tab;
        switch(this.state.tab){
            case 'profile':
                tab = <ProfileTab styles={{maxWidth: '50rem'}}/>
                break
            case 'preferences':
                tab = <PreferencesTab styles={{maxWidth: '50rem'}}/>
                break
            case 'subscription' :
                tab = <SubscriptionTab/>
                break
            default:
                tab = <div>Something went wrong</div>
        }

        let optionBlocks = []
        Object.keys(this.tabs).map(tab => {
            optionBlocks.push(
                <ListTile text={tab} icon={this.tabIcons[tab]} 
                styles={this.state.tab === tab ? this.selectedTile : this.styles} 
                    onSelect={() => this.setState({tab: tab})}/>
            )
        })

        return (
            <Wrapper>
                <Container>
                    <Title>Settings</Title>
                    <Header>
                        <Tabs onSelect={(tab) => this.setState({tab: tab}, console.log(tab))} styles={this.tabStyle} type='underline'
                            options={this.tabs}
                            selected={this.state.tab}/>
                    </Header>
                    {tab}
                </Container>
            </Wrapper>
        )
    }

}

const mapStateToProps = state => {
    return {
        uid: state.auth.uid,
        user: state.auth.user,
        data: state.db.present.data && state.db.present.data.toJS(),
        activePageID: state.auth.activePageID,

        window: state.content.window,
        body: state.content.body
    }
};

const mapDispatchToProps = dispatch => {
    return {
        setModal: (element, id) => dispatch(actionCreators.setModal(element, id)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(SettingsModule);